import PopupAbstract from 'pk/components/Popup/PopupAbstract'
import { markRaw } from 'vue'
import PopupFollowOfficialAccounts from './PopupFollowOfficialAccounts.vue'

export default class PopupFollowOfficialAccountsService extends PopupAbstract {
  public name = 'PopupFollowOfficialAccountsService'
  protected component = markRaw(PopupFollowOfficialAccounts)
}
